var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:outline-account-box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.7083 4.375H7.29167C5.6875 4.375 4.375 5.6875 4.375 7.29167V27.7083C4.375 29.3125 5.6875 30.625 7.29167 30.625H27.7083C29.3125 30.625 30.625 29.3125 30.625 27.7083V7.29167C30.625 5.6875 29.3125 4.375 27.7083 4.375ZM24.7917 27.7083H10.2083V27.3583C12.2792 25.6958 14.8167 24.7917 17.5 24.7917C20.1833 24.7917 22.7208 25.6958 24.7917 27.3583V27.7083ZM27.7083 26.0458C25.0833 23.4646 21.4813 21.875 17.5 21.875C13.5188 21.875 9.91667 23.4646 7.29167 26.0458V7.29167H27.7083V26.0458ZM17.5 18.9583C20.3146 18.9583 22.6042 16.6687 22.6042 13.8542C22.6042 11.0396 20.3146 8.75 17.5 8.75C14.6854 8.75 12.3958 11.0396 12.3958 13.8542C12.3958 16.6687 14.6854 18.9583 17.5 18.9583ZM17.5 11.6667C18.7104 11.6667 19.6875 12.6438 19.6875 13.8542C19.6875 15.0646 18.7104 16.0417 17.5 16.0417C16.2896 16.0417 15.3125 15.0646 15.3125 13.8542C15.3125 12.6438 16.2896 11.6667 17.5 11.6667Z",
    fill: "#065AD8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.6ca3f2e2cddc04b48e9a78433299dc04.svg";
export { ForwardRef as ReactComponent };